import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import AeMaxPrice from './AeMaxPrice';
import ErrorResponse from './ErrorResponse';
import mapAeMaxPrice from './mapAeMaxPrice';
import ProductUpdate from './ProductUpdate';
import ReferenceUpdate from './ReferenceUpdate';

export interface Result {
	aeMaxPrice: AeMaxPrice;
}

export default async function updateAeMaxPrice(
	client: ApiClient,
	userId: string,
	groupId: string,
	reference: ReferenceUpdate,
	products: ProductUpdate[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ae-max-price');
	const body = JSON.stringify({
		reference: {
			referenceBasketVersion: reference.referenceBasketVersion,
			generalInformation: {
				productName: reference.generalInformation.productName,
				scientificName: reference.generalInformation.scientificName,
				concentration: reference.generalInformation.concentration,
				pharmaceuticalForm: reference.generalInformation.pharmaceuticalForm,
				packSize: reference.generalInformation.packSize,
				companyName: reference.generalInformation.companyName,
			},
			proposedCifPrice: reference.proposedCifPrice,
			countryOfOrigin: {
				nationality: reference.countryOfOrigin.nationality,
				exFactoryPrice: reference.countryOfOrigin.exFactoryPrice,
				wholesalePrice: reference.countryOfOrigin.wholesalePrice,
				publicPrice: reference.countryOfOrigin.publicPrice,
			},
		},
		products: products.map((product) => ({
			id: product.id,
			packageSizeForSingleUnit: product.packageSizeForSingleUnit,
			priceTypeForCalculation: product.priceTypeForCalculation,
			selected: product.selected,
		})),
	});

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
			body,
		});
		const response = await request.json();
		return { aeMaxPrice: mapAeMaxPrice(response.aeMaxPrice) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
